import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { BvAlertComponent } from "./primitives/alert.component";
import { BvAvatarComponent } from "./primitives/avatar.component";
import { BvBadgeComponent } from "./primitives/badge.component";
import { BvButtonComponent } from "./primitives/button.component";
import {
  BvCardBodyComponent,
  BvCardComponent,
  BvCardDescComponent,
  BvCardFooterComponent,
  BvCardHeaderComponent,
  BvCardTitleComponent,
} from "./primitives/card.component";
import { BvCheckboxComponent } from "./primitives/checkbox.component";
import { BvChipComponent } from "./primitives/chip.component";
import { BvChipDesignPickerComponent } from "./primitives/chip-design-picker.component";
import { BvColorSwatchComponent } from "./primitives/color-swatch.component";
import { BvClusterComponent } from "./primitives/cluster.component";
import {
  BvDialogBodyComponent,
  BvDialogComponent,
  BvDialogFooterComponent,
  BvDialogTitleComponent,
} from "./primitives/dialog.component";
import { BvDialogContainerComponent } from "./primitives/dialog.service";
import { BvToastComponent } from "./primitives/toast.service";
import { BvEmptyStateComponent } from "./primitives/empty-state.component";
import { BvFormFieldComponent } from "./primitives/form-field.component";
import { BvGridComponent } from "./primitives/grid.component";
import { BvIconComponent } from "./primitives/icon.component";
import { BvDateInputDirective } from "./primitives/date-input.directive";
import { BvInputDirective } from "./primitives/input.directive";
import { BvTimeInputDirective } from "./primitives/time-input.directive";
import {
  BvMenuComponent,
  BvMenuItemComponent,
  BvMenuTriggerForDirective,
} from "./primitives/menu.component";
import {
  BvRadioComponent,
  BvRadioGroupComponent,
} from "./primitives/radio.component";
import { BvSpacerComponent } from "./primitives/spacer.component";
import { BvSpinnerComponent } from "./primitives/spinner.component";
import { BvLogoLoaderComponent } from "./primitives/logo-loader.component";
import { BvStackComponent } from "./primitives/stack.component";
import { BvStatusBadgeComponent } from "./primitives/status-badge.component";
import { BvSwitchComponent } from "./primitives/switch.component";
import {
  BvTabComponent,
  BvTabLabelDirective,
  BvTabsComponent,
} from "./primitives/tabs.component";
import {
  BvToggleComponent,
  BvToggleGroupComponent,
} from "./primitives/toggle-group.component";
import {
  BvTooltipContainerComponent,
  BvTooltipDirective,
} from "./primitives/tooltip.directive";

const BV_PRIMITIVES = [
  // Layout
  BvStackComponent,
  BvClusterComponent,
  BvGridComponent,
  BvSpacerComponent,
  // Content
  BvButtonComponent,
  BvCardComponent,
  BvCardHeaderComponent,
  BvCardTitleComponent,
  BvCardDescComponent,
  BvCardBodyComponent,
  BvCardFooterComponent,
  BvIconComponent,
  BvBadgeComponent,
  BvStatusBadgeComponent,
  BvAlertComponent,
  BvSpinnerComponent,
  BvLogoLoaderComponent,
  BvEmptyStateComponent,
  BvAvatarComponent,
  BvChipComponent,
  BvColorSwatchComponent,
  BvChipDesignPickerComponent,
  // Forms
  BvInputDirective,
  BvTimeInputDirective,
  BvDateInputDirective,
  BvFormFieldComponent,
  BvSwitchComponent,
  BvCheckboxComponent,
  BvRadioGroupComponent,
  BvRadioComponent,
  // Overlays
  BvDialogComponent,
  BvDialogTitleComponent,
  BvDialogBodyComponent,
  BvDialogFooterComponent,
  BvTooltipDirective,
  BvTooltipContainerComponent,
  BvMenuComponent,
  BvMenuItemComponent,
  BvMenuTriggerForDirective,
  // Composites
  BvTabsComponent,
  BvTabComponent,
  BvTabLabelDirective,
  BvToggleGroupComponent,
  BvToggleComponent,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        OverlayModule,
        PortalModule,
        A11yModule,
        ScrollingModule,
        TranslateModule,
        ...BV_PRIMITIVES, BvDialogContainerComponent, BvToastComponent,
    ],
    exports: BV_PRIMITIVES,
})
export class DesignSystemModule {}
